import SVG from 'react-inlinesvg';
import styles from './index.module.scss';
import linePayLogo from '@autopass-web/mochi-payment/assets/linepay_logo.png';
import easyWalletLogo from './assets/easy_wallet_logo.svg';
import jkoPayLogo from './assets/jko_pay_logo.svg';
import { isAppleSupportVersion, isLineInAppWebView } from './utils/support';
import {
  CAPTURE_TYPES,
  PAYMENT_METHODS,
  RECEIPT_TYPES,
} from '@autopass-web/domain';

export const PAYMENT_CONFIG = {
  [PAYMENT_METHODS.APPLE_PAY]: {
    optionView: (
      <div
        className={`${styles['apple-pay-button']} ${styles['apple-pay-button-white']}`}
      />
    ),
    optionSupport: () => {
      return (
        isAppleSupportVersion() &&
        !!window.ApplePaySession &&
        !isLineInAppWebView()
      );
    },
    emailSupport: false,
  },
  [PAYMENT_METHODS.LINE_PAY]: {
    optionView: <img src={linePayLogo} alt="line_pay" />,
    optionSupport: true,
    emailSupport: true,
  },
  [PAYMENT_METHODS.EASY_WALLET]: {
    optionView: <img src={easyWalletLogo} alt="easy_wallet" />,
    optionSupport: (amount, captureType, noReceiptIssue) => {
      return (
        !noReceiptIssue &&
        captureType === CAPTURE_TYPES.AUTO &&
        parseInt(amount) <= 30000
      );
    },
    emailSupport: true,
  },
  [PAYMENT_METHODS.JKOPAY]: {
    optionView: <img src={jkoPayLogo} alt="jko_pay" />,
    optionSupport: true,
    emailSupport: true,
  },
  [PAYMENT_METHODS.CREDIT_CARD]: {
    optionView: (
      <div className={styles['credit-card']}>
        <div>
          <SVG src="/assets/creditcard.svg" />
          信用卡/簽帳金融卡
        </div>
        <div>使用指定銀行信用卡優惠</div>
      </div>
    ),
    optionSupport: true,
    emailSupport: true,
  },
};

export const DEFAULT_RECEIPT_TYPES = [
  RECEIPT_TYPES.CARRIER_MOBILE_BARCODE,
  RECEIPT_TYPES.B2B,
  RECEIPT_TYPES.DONATE,
  RECEIPT_TYPES.CARRIER_MEMBER,
];

export const CHAIN_STORE_NO_RECEIPT_EMAIL =
  'chainstore_noreceipt@pklotcorp.com';
